export default __webpack_public_path__ + "static/media/tic-tac-toe.73e8a334.png";